import React,{useState, useEffect} from 'react'
import { useSelector } from 'react-redux'
import { CheckCircle, LoginIcon, LogoutIcon, LongBreak, Salah, ShortBreak, Washroom } from '../layout/Icons'
import axios from '../../api/axios'
import { ADD_ACTIVITY, CHECK_CLOCK_IN, CLOCK_IN_USER, CLOCK_OUT_USER, COMPLETE_ACTIVITY } from '../../api/ApiUrl'
import toast from 'react-hot-toast'
import moment from 'moment';
import { auth, submitMsg, updateActivity } from '../../config/firebaseConfig'
import { serverTimestamp } from 'firebase/firestore'

const activityConfig={
    1:{name:'Washroom', className:'bg-indigo-800', icon:<Washroom iconClass={'w-4 h-4'}/>},
    2:{name:'Short Break', className:'bg-orange-500', icon:<ShortBreak iconClass={'w-4 h-4'}/>},
    3:{name:'Long Break', className:'bg-red-500', icon:<LongBreak iconClass={'w-4 h-4'}/>},
    4:{name:'Salah Break', className:'bg-cyan-500', icon:<Salah iconClass={'w-4 h-4'}/>},
}

const ActionMsg = ({roomId}) => {
  
    const [load,setLoad]=useState(true);
    const [isClockIn, setIsClockIn]=useState(false);
    const user=useSelector((state)=>state.user.value);
    const [runningActivityId, setRunningActivityId]=useState(-1);
    const [indexId, setIndexId]=useState(-1);
    const [activityStartedAt, setActivityStartedAt]=useState(null);
    const [elapsedSeconds, setElapsedSeconds]=useState(0);

    useEffect(()=>{
        if(runningActivityId>0 && !activityStartedAt){
            setActivityStartedAt(new Date());
        }
        if(runningActivityId<=0){
            setActivityStartedAt(null);
            setElapsedSeconds(0);
        }
    },[runningActivityId, activityStartedAt])

    useEffect(()=>{
        if(runningActivityId<=0 || !activityStartedAt) return;
        const timer=setInterval(()=>{
            setElapsedSeconds(Math.max(0, Math.floor((Date.now()-activityStartedAt.getTime())/1000)));
        },1000);
        return()=>clearInterval(timer);
    },[runningActivityId, activityStartedAt])

    useEffect(()=>{
        const checkClockIn=async()=>{
            const res=await axios.post(CHECK_CLOCK_IN, {userId:user.id, compId:roomId});
            setIsClockIn(res.data.check)
            setRunningActivityId(res.data.act)
            setIndexId(res.data.actIndex);
            setLoad(false);
        }
        checkClockIn();
    },[user])

    const clockIn=async()=>{
        try{
            const uid=auth.currentUser?.uid;
            if(!uid){
                toast.error('Chat is still connecting');
                return;
            }
            
            if(isClockIn){
                toast.error('You are already clocked In for today');
                return
            }

            const res=await axios.post(CLOCK_IN_USER,{userId:user.id, compId:roomId});
            setIsClockIn(res.data.clockIn);
            updateActivity(roomId, user.id, 0)

            const time=moment(res.data.clockInTime).format('hh:mmA')
            const msg=`at ${time}`
            var img=null;
            if(user.image!=null){
                img=user.image
            }
            
            var data={
                createdAt:serverTimestamp(),
                msg:msg,
                photoUrl:img,
                roomId:roomId,
                uName:`${user.Fname} ${user.Lname}`,
                uid:uid,
                userId:user.id,
                msgType:2,
                typeId:0,
                read:[user.id],
            }
            submitMsg(roomId, data);

            toast.success('clocked-in for today');

        }catch(e){
            if(!e?.response){
                toast.error("No Server Response!");
                console.log(e);
            }else{
                console.log(e);
                toast.error("Oops! An error occured!");
            }
        }
    }



    const addActivity=async(actId, actName)=>{
        try{
            const uid=auth.currentUser?.uid;
            if(!uid){
                toast.error('Chat is still connecting');
                return;
            }
            
            if(runningActivityId>0){
                toast.error('please complete current running activity');
                return
            }
           

            const res=await axios.post(ADD_ACTIVITY,{userId:user.id, actId:actId, actName:actName, compId:roomId});
            setRunningActivityId(res.data.actId);
            setIndexId(res.data.indexId)
            setActivityStartedAt(res.data.startTime ? new Date(res.data.startTime) : new Date());
            updateActivity(roomId, user.id, actId);
            
            const time=moment(res.data.startTime).format('hh:mmA')
            const msg=`at ${time}`
            var img=null;
            if(user.image!=null){
                img=user.image
            }
            
            var data={
                createdAt:serverTimestamp(),
                msg:msg,
                photoUrl:img,
                roomId:roomId,
                uName:`${user.Fname} ${user.Lname}`,
                uid:uid,
                userId:user.id,
                msgType:2,
                typeId:actId, // type  for activity msgs
                read:[user.id],
            }

            submitMsg(roomId, data); 
        }catch(e){
            if(!e?.response){
                toast.error("No Server Response!");
                console.log(e);
            }else{
                console.log(e);
                toast.error("Oops! An error occured!");
            }
        }
    }

    const completeActivity=async(actId, refId)=>{
        try{
            const uid=auth.currentUser?.uid;
            if(!uid){
                toast.error('Chat is still connecting');
                return;
            }
            
            const res=await axios.post(COMPLETE_ACTIVITY,{userId:user.id, actId:actId, compId:roomId});
            setRunningActivityId(res.data.actId);
            setIndexId(-1)
            setActivityStartedAt(null);
            setElapsedSeconds(0);
            updateActivity(roomId, user.id, 0);

            const startTime=moment(res.data.startTime).format('hh:mmA')
            const endTime=moment(res.data.endTime).format('hh:mmA')
            console.log(res.data.startTime)
            console.log(res.data.endTime)
            const duration=moment.duration(moment(res.data.endTime).diff(moment(res.data.startTime)));
            const durationText=`${Math.floor(duration.asHours())}h ${duration.minutes()}m ${duration.seconds()}s`;
            const msg=`${startTime} - ${endTime} (${durationText})`
            var img=null;
            if(user.image!=null){
                img=user.image
            }

            var data={
                createdAt:serverTimestamp(),
                msg:msg,
                photoUrl:img,
                roomId:roomId,
                uName:`${user.Fname} ${user.Lname}`,
                uid:uid,
                userId:user.id,
                msgType:2,
                typeId:refId,
                completeType:true,
                read:[user.id],
            }

            submitMsg(roomId, data); // type 2 for activity msgs

        }catch(e){
            if(!e?.response){
                toast.error("No Server Response!");
                console.log(e);
            }else{
                console.log(e);
                toast.error("Oops! An error occured!");
            }
        }
    }

    const formatElapsed=(seconds)=>{
        const hrs=Math.floor(seconds/3600);
        const mins=Math.floor((seconds%3600)/60);
        const secs=seconds%60;
        return `${hrs.toString().padStart(2,'0')}:${mins.toString().padStart(2,'0')}:${secs.toString().padStart(2,'0')}`;
    }

    const activeActivity=activityConfig[runningActivityId];


    

    const clockOut=async()=>{
        try{
            const uid=auth.currentUser?.uid;
            if(!uid){
                toast.error('Chat is still connecting');
                return;
            }
            
            if(!isClockIn){
                toast.error('You are already clocked Out for today');
                return
            }

            const res=await axios.post(CLOCK_OUT_USER,{userId:user.id, compId:roomId});
            setIsClockIn(res.data.clockIn);
            updateActivity(roomId, user.id, -1)

            const time=moment(res.data.clockOutTime).format('hh:mmA')
            const msg=`at ${time}`
            var img=null;
            if(user.image!=null){
                img=user.image
            }
            var data={
                createdAt:serverTimestamp(),
                msg:msg,
                photoUrl:img,
                roomId:roomId,
                uName:`${user.Fname} ${user.Lname}`,
                uid:uid,
                userId:user.id,
                msgType:2,
                typeId:-1,
                read:[user.id],
            }
            submitMsg(roomId, data);

            toast.success('clocked-out for today');

        }catch(e){
            if(!e?.response){
                toast.error("No Server Response!");
                console.log(e);
            }else{
                console.log(e);
                toast.error("Oops! An error occured!");
            }
        }
    }
    

  return !load?(
    <div className='messenger-actions'>
        {activeActivity?
        <div className='activity-focus-overlay'>
            <div className='activity-focus-modal'>
                <div className={`activity-focus-icon ${activeActivity.className}`}>
                    {activeActivity.icon}
                </div>
                <p className='activity-focus-eyebrow'>Current status</p>
                <h3>{activeActivity.name}</h3>
                <p className='activity-focus-timer'>{formatElapsed(elapsedSeconds)}</p>
                <button className={`activity-focus-return ${activeActivity.className}`} onClick={()=>completeActivity(indexId,runningActivityId)}>
                    {activeActivity.icon}
                    <span>Back to tasks</span>
                </button>
            </div>
        </div>
        :
        null}
        <div className='messenger-actions-row'>
            <div className='flex flex-col items-center justify-center gap-1'>

            <button className='bg-green-500 action-btn group' onClick={()=>{clockIn()}} disabled={isClockIn}>
                <LoginIcon iconClass={'w-4 h-4'}/>
                <p className='action-btn-text group-hover:scale-100'>Clock-in</p>
            </button>
           
            </div>


    

            <button className={`bg-indigo-800 action-btn group`} onClick={()=>{if(runningActivityId==1) {completeActivity(indexId,1)} else  {addActivity(1,'washroom')} }} disabled={runningActivityId>0 && runningActivityId!=1}>
            {runningActivityId==1?
                <CheckCircle iconClass={'w-4 h-4'}/>
                :
                <Washroom iconClass={'w-4 h-4'}/>
            }
                <p className='action-btn-text group-hover:scale-100'>Washroom</p>
            </button>
            
   

           

            <button className='bg-orange-500 action-btn group' onClick={()=>{if(runningActivityId==2){ completeActivity(indexId,2)}else {addActivity(2,'short-break')}}} disabled={runningActivityId>0 && runningActivityId!=2}>
                {runningActivityId==2?
                <CheckCircle iconClass={'w-4 h-4'}/>
                :
                <ShortBreak iconClass={'w-4 h-4'}/>
                }
                <p className='action-btn-text group-hover:scale-100'>Short Break</p>
            </button>

        
         

            <button className='bg-red-500 action-btn group' onClick={()=>{if(runningActivityId==3){ completeActivity(indexId,3)} else{ addActivity(3,'Long-break')}}} disabled={runningActivityId>0 && runningActivityId!=3}>
                {runningActivityId==3?
                <CheckCircle iconClass={'w-4 h-4'}/>
                :
                <LongBreak iconClass={'w-4 h-4'}/>
                }
                <p className='action-btn-text group-hover:scale-100'>Long Break</p>
            </button>

 

            

            <button className='bg-cyan-500 action-btn group' onClick={()=>{if(runningActivityId==4){completeActivity(indexId,4)} else{addActivity(4,'Salah-break')}}} disabled={runningActivityId>0 && runningActivityId!=4}>
                {runningActivityId==4?
                <CheckCircle iconClass={'w-4 h-4'}/>
                :
                <Salah iconClass={'w-4 h-4'}/>
                }
                <p className='action-btn-text group-hover:scale-100'>Salah Break</p>
            </button>

            <div className='flex flex-col items-center justify-center gap-1'>

            <button className='bg-rose-500 action-btn group' onClick={()=>{clockOut()}} disabled={!isClockIn}>
                <LogoutIcon iconClass={'w-4 h-4'}/>
                <p className='action-btn-text group-hover:scale-100'>Clock-out</p>
            </button>
            
            </div>

        </div>
    </div>
  ):
  null
}

export default ActionMsg
